import HomePage from './HomePage'
import enhance from './HomePage.enhancer'

export default enhance(HomePage)
